import React from 'react'
import { CreateAttatchFileFormTrainContainer } from '../../containers/Officer/CreateAttatchFileFormTrainContainer'
export const CreateAttatchFileFormTrainPage = () => {
  return (
    <CreateAttatchFileFormTrainContainer />
  )
}
